import { Injectable } from '@angular/core';
import { SearchOutputModel } from 'src/app/models/search-output-model';
import {
  ActivatedRouteSnapshot,
  Resolve,
} from '@angular/router';
import { Observable, of, EMPTY, mergeMap, take } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { PubSearchService } from '../services/pub-search.service';
import { QueryStateService } from '../services/query-state.service';
import { MetadataService } from '../services/metadata.service';
import { UserPreferencesService } from '../services/user-preferences.service';

@Injectable({
  providedIn: 'root'
})
export class SearchResolverService implements Resolve<SearchOutputModel> {
  constructor(private searchSvc: PubSearchService, private queryStateSvc: QueryStateService,
    private messageSvc: MessageService, private mdSvc: MetadataService,
    private userPrefSvc: UserPreferencesService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const qData = route.paramMap.get('q');

    if (qData) {
          return this.mdSvc.getMetadata().pipe(
            tap(data => {
              this.queryStateSvc.updateMetadataProps(data);
              this.mdSvc.mdItems = data;
            }),
            switchMap(() => {
              return this.executeSearch(qData); })
          );
    }
    else {
      this.messageSvc.add({ summary: 'There was an error retrieving results!', severity: "error", detail: "No Query was sent!" })
      return EMPTY;
    }
  }

  executeSearch(qData: string) {
    let formData: any = JSON.parse(decodeURIComponent(qData));
    this.queryStateSvc.updateFormData(formData);
    this.queryStateSvc.resetSort();

    // Restore user's saved sort preference so the first fetch respects it
    const savedSort = this.userPrefSvc.loadSort();
    if (savedSort) {
      this.queryStateSvc.updateSelectedSort(savedSort);
    }

    //  console.log("fd: " + JSON.stringify(formData));
    // console.log("sr2: " + JSON.stringify(this.queryStateSvc.getUpdatedSearchRequest()));
    return this.searchSvc.getSearchResultsReq(this.queryStateSvc.getUpdatedSearchRequest()).pipe(
      take(1),
      mergeMap((e: SearchOutputModel) => {
        if (e) {
          e.queryData = qData;
          return of(e);
        } else {
          return EMPTY;
        }
      })
    );
  }
}
